export const homeHero = {
  eyebrow: "Evidence-led creative growth",
  headline: "Evidence-led creative growth for brands and agencies",
  answer:
    "Agentic Plus turns product facts, brand knowledge, market evidence, and growth goals into organized creative missions. A scoped Growth Agent prepares briefs, images, standard video, and decision records while people retain control over brand, spend, and external actions.",
  primaryCta: { label: "Request a demo", href: "/contact" },
  secondaryCta: { label: "See how it works", href: "/how-it-works" },
};

export const workflow = [
  {
    title: "Input",
    description:
      "Start with a product URL, growth goal, creative question, brand brief, or prior asset set.",
  },
  {
    title: "Evidence",
    description:
      "Organize product facts, brand guidance, historical creative, and authorized market signals.",
  },
  {
    title: "Strategy",
    description:
      "Translate evidence into a brief, hypothesis, format plan, and measurable success signal.",
  },
  {
    title: "Production",
    description: "Generate copy, images, and standard video while preserving brand constraints.",
  },
  {
    title: "Approval",
    description: "Review assets, cost, context, and execution plans before work moves forward.",
  },
  {
    title: "Delivery",
    description:
      "Deliver approved versions with destination, provider state, and compensation context.",
  },
  {
    title: "Learning",
    description: "Connect review findings and authorized results to the next creative decision.",
  },
];

export const capabilities = [
  {
    title: "Growth Agent",
    description:
      "A scoped agent turns an objective into a reviewable mission plan and exposes the evidence behind each next action.",
    status: "Pilot",
  },
  {
    title: "Growth Mission",
    description:
      "A mission is the trackable container for an objective, inputs, evidence, briefs, assets, approvals, and outcomes.",
    status: "Available",
  },
  {
    title: "Evidence Graph",
    description:
      "Facts, brand guidance, historical creative, and market signals keep their source, time, verification state, and evidence level.",
    status: "Available",
  },
  {
    title: "Brand Brain",
    description:
      "Reusable brand and product context keeps voice, claims, constraints, and approved facts available across work.",
    status: "Available",
  },
  {
    title: "Creative Intelligence",
    description:
      "Organize authorized creative and market inputs so teams can compare patterns and identify test opportunities.",
    status: "Available",
  },
  {
    title: "Creative Production",
    description:
      "Generate campaign copy, images, and standard video from an approved brief with version history.",
    status: "Available",
  },
  {
    title: "Approval & Governance",
    description:
      "Review spend, assets, and external actions before delivery; record who approved which version or plan.",
    status: "Available",
  },
  {
    title: "Experiment Memory",
    description:
      "Connect hypotheses, variants, decisions, outcomes, and post-mortems so learning is reusable, not buried in chat.",
    status: "Pilot",
  },
  {
    title: "Governed Distribution",
    description:
      "Preview external actions, enforce scoped permissions, read back provider state, and preserve a compensation path.",
    status: "Pilot",
  },
];

export const audiences = [
  {
    title: "Brand growth leaders",
    points: [
      "Turn product facts and goals into a repeatable creative process",
      "Keep claims, offers, and brand constraints visible",
      "Compare creative options before committing spend",
    ],
  },
  {
    title: "Agency teams",
    points: [
      "Separate client context by workspace",
      "Reuse approved brand guidance without starting over",
      "Give stakeholders a reviewable asset and decision trail",
    ],
  },
  {
    title: "Media buyers",
    points: [
      "Know which creative version is approved for delivery",
      "Keep production decisions connected to campaign context",
      "Use read-only analysis to inform the next test",
    ],
  },
];

export const controls = [
  {
    title: "Workspace isolation",
    description: "Client and brand context stay separated inside scoped workspaces.",
  },
  {
    title: "Human approval",
    description: "High-cost generation and external actions require explicit authorization.",
  },
  {
    title: "Version control",
    description: "Each asset retains its brief, source context, model run, and version lineage.",
  },
  {
    title: "Action traceability",
    description: "Task state, evidence, and approved changes remain reviewable after execution.",
  },
  {
    title: "Evidence separation",
    description: "Verified facts, assumptions, and model inference remain distinguishable.",
  },
  {
    title: "Compensation paths",
    description: "External actions preserve a stop, undo, or exception path where supported.",
  },
];
